module.exports = __webpack_public_path__ + "static/media/Sarmayeh.7338a2ba.svg";